var CUJEvents = /* @__PURE__ */ ((CUJEvents2) => {
  CUJEvents2["SDK_INIT"] = "sdk_init";
  CUJEvents2["FETCH_DATA"] = "fetch_data";
  CUJEvents2["UPDATE_RECORD"] = "update_record";
  CUJEvents2["GET_RECORD"] = "get_record";
  CUJEvents2["GET_RECORDS"] = "get_records";
  CUJEvents2["GET_ENTITY"] = "get_entity";
  CUJEvents2["GET_ENTITIES"] = "get_entities";
  CUJEvents2["SUBSCRIBE_EVENT"] = "subscribe_event";
  CUJEvents2["UNSUBSCRIBE_EVENT"] = "unsubscribe_event";
  return CUJEvents2;
})(CUJEvents || {});
const TEA_EVENT_NAME_MAPPING = {
  ["sdk_init" /* SDK_INIT */]: "consent_init_sdk",
  ["fetch_data" /* FETCH_DATA */]: "consent_fetch_data",
  ["update_record" /* UPDATE_RECORD */]: "consent_create_record_api",
  ["get_record" /* GET_RECORD */]: "consent_get_record",
  ["get_records" /* GET_RECORDS */]: "consent_get_records",
  ["get_entity" /* GET_ENTITY */]: "consent_get_entity",
  ["get_entities" /* GET_ENTITIES */]: "consent_get_entities",
  ["subscribe_event" /* SUBSCRIBE_EVENT */]: "consent_subscribe_event",
  ["unsubscribe_event" /* UNSUBSCRIBE_EVENT */]: "consent_unsubscribe_event"
};
export {
  CUJEvents,
  TEA_EVENT_NAME_MAPPING
};
